<template>
<div v-if="currentOffer !== null">
  <celebrate-graphics title="Congratulations">
    <template slot="content">
      <p class="text" v-if="isOffer">{{ currentOffer.updatedAt | formatDate }} • Congratulations on your job offer from {{ currentJob.companyName }}!
        Please see the job offer details below. Feel free to Accept or Reject the offer. Any questions message us by clicking the green chat widget below.
      </p>
      <p class="text" v-else>{{ currentOffer.updatedAt | formatDate }} • Congratulations on your job offer from {{ currentJob.companyName }}!
        Please see the job offer details below. Any questions message us by clicking the green chat widget below.
      </p>
    </template>
  </celebrate-graphics>
  <divider />
  <heading>Offer For</heading>
  <row-card
  :imageUrl="currentJob.companyImageUrl" :leftTitle="currentJob.title"
  :leftSubtitle="`${currentJob.companyName} • ${currentJob.locations.join(', ')}`"
  :rightTitle="salary" :rightSubtitle="currentJob.contract">
  </row-card>
  <divider />
  <heading>Salary Offer</heading>
  <p v-if="currentOffer.salary">
    ${{currentOffer.salary.toLocaleString()}}
  </p>
  <p v-else>
    $0
  </p>
  <divider />
  <heading>Start date</heading>
  <p>
    {{currentOffer.startDate | formatDate}}
  </p>
  <divider />
  <div v-if="currentApplication.referralId !== null">
    <heading>Referrer</heading>
      <user-row-card :user="user" />
    <divider />
    <heading>Referral Reward</heading>
      <reward :min="null" :max="referrerRewardMax" :rewardPercentage="currentJob.rewardPercentage" cssClass="inline normal f-14" title="in HVT *" :referrer="currentApplication.referralId !== null" />
    <divider />
  </div>
  <heading>Your Reward</heading>
    <reward :min="null" :max="referrerRewardMax" :rewardPercentage="currentJob.rewardPercentage" cssClass="inline normal f-14" title="in HVT *" :referrer="currentApplication.referralId !== null" />
  <divider />
  <heading>* Reward Terms</heading>
  <p class="text">
    This is 100% of your total Job Hire Reward. 33.3% is released when 30 days is completed after your start date.
    The next 33.3% is released when 60 days is compelted, and the final 33.4% is released when 90 days is completed.
  </p>
  <divider />
  <heading>Status</heading>
  <p>{{ currentJob.applicationStatus | capitalize }} • Last updated {{ currentJob.applicationUpdatedAt | formatDate }} </p>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Divider from '@/components/general/divider'
import Heading from '@/components/general/heading'
import Field from '@/components/general/field'
import RowCard from '@/components/general/row-card'
import _ from 'lodash'
import moment from 'moment'
import JobSalary from '@/components/general/job-salary'
import GlobalData from '@/helpers/global-data'
import Reward from '@/components/jobs/reward'
import RewardHelper from '@/helpers/reward'
import UserRowCard from '@/components/general/user-row-card'
import CelebrateGraphics from '@/components/general/celebrate-graphics'

export default {
  components: { Divider, Heading, Field, RowCard, JobSalary, Reward, UserRowCard, CelebrateGraphics },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    isOffer: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters('jobs', [
      'currentJob',
      'currentOffer',
      'currentApplication'
    ]),
    salary () {
      return JobSalary.methods.salary(this.currentJob)
    },
    referralFraction () {
      return GlobalData.referralFraction()
    },
    totalReward () {
      return RewardHelper.totalReward(this.currentOffer.salary, this.currentJob.rewardPercentage)
    },
    referrerRewardMax () {
      const f = this.currentApplication.referralId ? this.referralFraction : 1
      return RewardHelper.user(this.totalReward, this.currentJob.rewardPercentage) * f
    },
    user: function () {
      let application = this.currentApplication
      let user = {
        profilePictureUrl: application.referrerProfilePictureUrl,
        firstName: application.referrerFirstName,
        lastName: application.referrerLastName,
        location: application.referrerLocation,
        role: application.referrerRole,
        companyName: application.referrerCompanyName
      }
      return user
    }
  },
  filters: {
    capitalize (value) {
      return _.capitalize(value)
    },
    formatDate (value) {
      return moment(value).format('DD MMM YY')
    }
  },
  async mounted () {

  }
}
</script>

<style lang="scss">
.field.is-spaced {
  display: flex;
  justify-content: space-between;
}
.is-right {
  float: right;
  color: #888;
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/offer-page.vue